import posthog from 'posthog-js'
import { CONSENT_KEY } from '@/hooks/use-consent'

type EventName = 'offer_claimed' | 'drops_purchased' | 'offer_viewed' | 'checkout_started'

interface EventProperties {
  offerId?: string
  priceDrops?: number
  drops?: number
  amount?: number
  [key: string]: unknown
}

function hasAnalyticsConsent(): boolean {
  try {
    const stored = localStorage.getItem(CONSENT_KEY)
    const prefs = stored ? JSON.parse(stored) : null
    return prefs?.analytics === true
  } catch {
    return false
  }
}

export function initAnalytics(key: string | undefined, host: string | undefined): void {
  if (!key || key.startsWith('__')) return
  posthog.init(key, {
    api_host: host ?? 'https://app.posthog.com',
    capture_pageview: true,
    autocapture: false,
    persistence: 'localStorage',
  })
}

export function trackEvent(name: EventName, props?: EventProperties): void {
  if (!hasAnalyticsConsent()) return
  posthog.capture(name, props)
}

export function identifyUser(userId: string): void {
  if (!hasAnalyticsConsent()) return
  posthog.identify(userId)
}
